<template>

	<base-table :service="$options.uiLiciousService" fetch-func="all" :fetch-params="$options.params" 

		:columns="$options.columns" default-sort-direction="desc" sticky :narrowed="false" ref="baseTable" >

        <template #scheduleId="{ row }">

            {{ contentData(row.content, 'run_id') }}
        
        </template>

        <template #name="{ row }">

            {{ contentData(row.content, 'name') }}
        
        </template>

        <template #status="{ row }">

            {{ contentData(row.content, 'status') }}
        
        </template>

        <template #ranOn="{ row }">

            {{ contentData(row.content, 'ran_on') }}
        
        </template>

        <template #duration="{ row }">

            <i class="fa fa-clock-o" aria-hidden="true"></i> {{ contentData(row.content, 'duration') }}
        
        </template>

        <template #action="{ row }">

            <a target="_blank" :href="row.content | link">
                
                <b-button size="is-small" >
                        
                    Link <i class="fa fa-external-link" aria-hidden="true"></i>
                
                </b-button>
            
            </a>
        
        </template>

	</base-table>

</template>

<script>

import BaseTable from "@/components/partials/BaseTable";

import { UiLiciousService } from "@/services/uilicious.service";

export default {

    uiLiciousService: UiLiciousService,

    columns: [

        { field: "content", label: "ID", meta: { rowSlot: "scheduleId" } },

        { field: "content", label: "Date", meta: { rowSlot: "ranOn" } },

        { field: "content", label: "Test", meta: { rowSlot: "name" } },

        { field: "content", label: "Status", meta: { rowSlot: "status" } },

        { field: "content", label: "Duration", meta: { rowSlot: "duration" } },

        { field: "content", label: "Action", meta: { rowSlot: "action" } },

    ],

    components: { BaseTable },

    filters: {

        link(data) {
            
            let content =  JSON.parse(data);

            return content[0].uilicious_link;

        }
    
    },

    methods: {
        
        fetch() {
        
            return this.$refs.baseTable.fetchData();
        
        },

        contentData(content, column) {

            return this.parseContent(content)[0][column];

        },

        parseContent(content) {

            return JSON.parse(content);

        }

    },
    
    mounted() {
        
        this.fetch();
    
    }
    
};

</script>


<style scoped>

.fa-external-link{

    margin: 3px 2px 0px;

}

</style>


// WEBPACK FOOTER //
// src/components/pages/UILicious/list.vue